module.exports = __webpack_public_path__ + "media/images/lp/lp01-b3ba34bb79428856b820afb7a6a37158.webp";